import { TranslateModule } from '@ngx-translate/core';
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { navItems } from '../sidebar/sidebar-data';
import { TranslateService } from '@ngx-translate/core';
import { LangService } from 'src/app/services/lang.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpErrorResponse } from '@angular/common/http';
import { AppSettings } from 'src/app/config';
import { jwtDecode } from "jwt-decode";
import { HttpClient, HttpEvent, HttpEventType, HttpResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { WarehouseService } from 'src/app/services/apps/warehouse/warehouse.service';
import { ImportResultComponent } from './import-result/import-result.component';
import { ImportResultDto } from './importResult/import-result.model';
import { WarehouseAccessService } from 'src/app/services/warehouse-access.service';

interface notifications {
  id: number;
  title: string;
  message: string;
  isRead: boolean;
}

interface profiledd {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;
}

interface apps {
  id: number;
  img: string;
  title: string;
  subtitle: string;
  link: string;

}

interface quicklinks {
  id: number;
  title: string;
  link: string;
}

@Component({
  selector: 'app-header',
  imports: [
    TranslateModule,
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
  ],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  private baseUrl = environment.apiUrl;
  showFiller = false;
  userInfo: any;

  public selectedLanguage: any = {
    language: 'English',
    code: 'en',
    type: 'US',
    icon: '/assets/images/flag/icon-flag-en.svg',
  };

  public languages: any[] = [
    {
      language: 'English',
      code: 'en',
      type: 'US',
      icon: '/assets/images/flag/icon-flag-en.svg',
    },
    {
      language: 'Español',
      code: 'es',
      icon: '/assets/images/flag/icon-flag-es.svg',
    },

  ];

  @Output() optionsChange = new EventEmitter<AppSettings>();
  notifications: notifications[] = []

  constructor(
    private settings: CoreService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private router: Router,
    private core: CoreService,
    private notification: NotificationService,
     private warehouseAccess: WarehouseAccessService,

  ) {
    translate.setDefaultLang('en');
  }
  /** El idioma de la persona (lo elige en su perfil o con EN | ES arriba). */
  L = inject(LangService);
  /** Solo quien maneja (choferes y managers) ve EN | ES arriba: sus pantallas están en los dos idiomas. */
  get showLang(): boolean {
    return ['Driver', 'Rsp', 'RentalDriver', 'Manager'].includes(this.userInfo?.role);
  }
  setLang(l: 'en' | 'es'): void {
    if (this.L.lang() === l) return;
    this.L.set(l).subscribe({ error: () => this.core.showError(this.L.t('Could not save your language.', 'No se pudo guardar tu idioma.')) });
  }
  ngOnInit(): void {

    this.loadUserInfo();
    this.L.load();
    this.loadNotifications();
  }

  options = this.settings.getOptions();

  openDialog() {
    const dialogRef = this.dialog.open(AppSearchDialogComponent);

    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }
  loadUserInfo(): void {
    const token = localStorage.getItem('token');

    if (!token) {
      console.warn('⚠️ No hay token en localStorage');
      this.userInfo = null;
      return;
    }

    try {
      const decoded: any = jwtDecode(token);

      // Validación mínima (no seas tan estricto o romperás login)
      if (!decoded) {
        console.error('❌ Token inválido');
        this.userInfo = null;
        return;
      }

      this.userInfo = {
        id: Number(decoded.nameid),                 // sub / nameid
        name: decoded.unique_name ?? decoded.name ?? 'Unknown',
        role: decoded.role,
        email: decoded.email,
        warehouseId: decoded.warehouseID ?? null,   // OJO naming
        companyId: decoded.companyId ?? null,
        avatarUrl: decoded.avatar_url ?? null
      };

    } catch (err) {
      console.error('❌ Error decodificando token', err);
      this.userInfo = null;
    }
  }

  loadNotifications() {
    const id = this.userInfo.id;

    this.notification.getNotifications(id).subscribe({
      next: (res) => {
        this.notifications = res

      }
    }
    )
  }
  get avatarImageUrl(): string {
    if (this.userInfo?.avatarUrl) {
      return `${this.baseUrl}/User/avatar/${this.userInfo.avatarUrl}`;
    }
    return '/assets/images/profile/user-1.jpg';
  }
  markAsRead(notification: any) {
    this.notification.markRead(notification).subscribe({
      next: () => {
        // ✅ Marcar como leído localmente
        notification.isRead = true;

        // ✅ (Opcional) Mostrar una notificación o actualizar el contador
        // this.toastr.success('Notificación marcada como leída');
      },
      error: (err: any) => {
        console.error('Error al marcar notificación como leída', err);
      }
    });
  }

  get unreadCount(): number {
    return this.notifications.filter(n => !n.isRead).length;
  }

  setlightDark(theme: string) {
    this.options.theme = theme;
    this.emitOptions();
  }

  changeLanguage(lang: any): void {
    this.translate.use(lang.code);
    this.selectedLanguage = lang;
    this.core
  }

  logout() {
    this.L.reset();
    this.settings.signOut();
    this.router.navigate(['/authentication/login']);
    this.core.showSuccess("Come back soon!!")
  }




  profiledd: profiledd[] = [
    {
      id: 1,
      img: '/assets/images/svgs/icon-account.svg',
      title: 'My Profile',
      subtitle: 'Account Settings',
      link: '/apps/account-setting',
    },
    {
      id: 2,
      img: '/assets/images/svgs/icon-inbox.svg',
      title: 'Notifications',
      subtitle: 'notificatios',
      link: '/apps/notification/inbox',
    },/** 
      {
        id: 3,
        img: '/assets/images/svgs/icon-tasks.svg',
        title: 'My Tasks',
        subtitle: 'To-do and Daily Tasks',
        link: '/apps/taskboard',
      },*/
  ];


}

@Component({
  selector: 'search-dialog',
  imports: [
    RouterModule,
    MaterialModule,
    TablerIconsModule,
    FormsModule
  ],
  templateUrl: 'search-dialog.component.html',
  styleUrls: ['./search-dialog.component.scss']
})
export class AppSearchDialogComponent {

  // ============================================================
  // FILES
  // ============================================================

  selectedFile: File | null = null;
  selectedFiles: File[] = [];

  fileType: 'report' | 'claims' | null = null;

  isLoading = false;

  // ============================================================
  // USER / WAREHOUSE
  // ============================================================

  userInfo: any = null;

  warehouses: any[] = [];

  selectedWarehouseId: number | null = null;

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private core: CoreService,
    private warehouseAccess: WarehouseAccessService,
    private dialog: MatDialog
  ) {}

  // ============================================================
  // ROLE ACCESS
  // ============================================================

  get isAdmin(): boolean {
    return this.warehouseAccess.isAdmin;
  }

  get canSelectWarehouse(): boolean {
    return this.warehouseAccess.canSelectWarehouse;
  }

  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    // Usuario desde token
    this.loadUserInfo();

    // Cargar warehouses permitidos.
    // WarehouseAccessService usa cache.
    this.warehouseAccess.loadWarehouses().subscribe({
      next: (warehouses: any[]) => {

        this.warehouses = warehouses || [];

        // ======================================================
        // Restaurar warehouse seleccionado previamente
        // ======================================================

        const cachedWarehouseId =
          this.warehouseAccess.selectedWarehouseId;

        if (
          cachedWarehouseId &&
          this.warehouses.some(
            w => Number(w.id) === Number(cachedWarehouseId)
          )
        ) {
          this.selectedWarehouseId =
            Number(cachedWarehouseId);

          return;
        }

        // ======================================================
        // Si solo tiene acceso a un warehouse
        // seleccionarlo automáticamente
        // ======================================================

        if (this.warehouses.length === 1) {

          this.selectedWarehouseId =
            Number(this.warehouses[0].id);

          this.warehouseAccess.setSelectedWarehouse(
            this.selectedWarehouseId
          );

          return;
        }

        // ======================================================
        // Usuario tradicional con WarehouseID
        // Driver/RSP/etc.
        // ======================================================

        if (
          !this.canSelectWarehouse &&
          this.userInfo?.warehouseID
        ) {

          const warehouseId =
            Number(this.userInfo.warehouseID);

          if (
            Number.isFinite(warehouseId) &&
            warehouseId > 0
          ) {
            this.selectedWarehouseId = warehouseId;
          }
        }
      },

      error: (err) => {

        console.error(
          'Error loading warehouses',
          err
        );

        this.snackBar.open(
          err?.error?.message ||
          'Error loading warehouses.',
          'Close',
          {
            duration: 5000
          }
        );
      }
    });
  }

  // ============================================================
  // USER INFO
  // ============================================================

  private loadUserInfo(): void {

    const token = localStorage.getItem('token');

    if (!token) {

      console.warn(
        '⚠️ No token found in localStorage'
      );

      this.userInfo = null;

      return;
    }

    try {

      const decodedToken: any =
        jwtDecode(token);

      if (!decodedToken) {

        console.error(
          '❌ Invalid token'
        );

        this.userInfo = null;

        return;
      }

      this.userInfo = {

        name:
          decodedToken.unique_name ??
          decodedToken.name ??
          'Unknown',

        id:
          Number(
            decodedToken.nameid ??
            decodedToken.sub ??
            0
          ),

        role:
          decodedToken.role,

        email:
          decodedToken.email,

        warehouseID:
          decodedToken.WarehouseID ??
          decodedToken.warehouseID ??
          decodedToken.warehouseId ??
          null,

        companyId:
          decodedToken.companyId ??
          null
      };

    } catch (error) {

      console.error(
        '❌ Error decoding token:',
        error
      );

      this.userInfo = null;
    }
  }

  // ============================================================
  // SELECT WAREHOUSE
  // ============================================================

  onWarehouseChange(
    warehouseId: number | null
  ): void {

    this.selectedWarehouseId =
      warehouseId;

    this.warehouseAccess
      .setSelectedWarehouse(
        warehouseId
      );

    // Reset files when warehouse changes
    this.selectedFile = null;
    this.selectedFiles = [];
    this.fileType = null;
  }

  // ============================================================
  // GET CURRENT WAREHOUSE ID
  // ============================================================

  private getWarehouseId(): number | null {

    if (this.selectedWarehouseId) {
      return Number(
        this.selectedWarehouseId
      );
    }

    // Fallback solamente para roles que
    // utilizan WarehouseID tradicional
    if (
      !this.canSelectWarehouse &&
      this.userInfo?.warehouseID
    ) {

      const id =
        Number(
          this.userInfo.warehouseID
        );

      return Number.isFinite(id) &&
        id > 0
        ? id
        : null;
    }

    return null;
  }

  // ============================================================
  // GET WAREHOUSE OBJECT
  // ============================================================

  private getSelectedWarehouse(
    warehouseId: number | string
  ): any | null {

    return this.warehouseAccess
      .getWarehouse(
        warehouseId
      );
  }

  // ============================================================
  // FILE SELECT
  // ============================================================

  onFileSelected(event: any): void {

    const files: File[] =
      Array.from(
        event?.target?.files || []
      );

    if (!files.length) {
      return;
    }

    const warehouseId =
      this.getWarehouseId();

    if (!warehouseId) {

      this.snackBar.open(
        'Please select a warehouse first.',
        'Close',
        {
          duration: 4000
        }
      );

      event.target.value = '';

      return;
    }

    const wh =
      this.getSelectedWarehouse(
        warehouseId
      );

    if (!wh) {

      this.snackBar.open(
        'Selected warehouse was not found.',
        'Close',
        {
          duration: 4000
        }
      );

      event.target.value = '';

      return;
    }

    const company =
      (wh.company ?? '')
        .toLowerCase()
        .trim();

    const isCargoVan =
      company === 'cargo van';

    // ==========================================================
    // MULTIPLE FILE VALIDATION
    // ==========================================================

    if (
      !isCargoVan &&
      files.length > 1
    ) {

      this.snackBar.open(
        'Only Cargo Van allows multiple files. Please select only one file.',
        'Close',
        {
          duration: 4000
        }
      );

      this.selectedFile = null;
      this.selectedFiles = [];

      event.target.value = '';

      return;
    }

    // ==========================================================
    // EXTENSIONS
    // ==========================================================

    let allowedExtensions: string[];

    if (
      this.fileType === 'claims'
    ) {

      allowedExtensions = [
        'xls',
        'xlsx'
      ];

    } else if (isCargoVan) {

      allowedExtensions = [
        'pdf'
      ];

    } else {

      allowedExtensions = [
        'xml',
        'xls',
        'xlsx'
      ];
    }

    const invalidFile =
      files.find(file => {

        const extension =
          file.name
            .split('.')
            .pop()
            ?.toLowerCase();

        return !allowedExtensions
          .includes(
            extension || ''
          );
      });

    if (invalidFile) {

      let message =
        'Please select a valid file.';

      if (
        this.fileType === 'claims'
      ) {

        message =
          'Claims only allows Excel files (.xls, .xlsx).';

      } else if (isCargoVan) {

        message =
          'Cargo Van only allows PDF files.';

      } else {

        message =
          'Please select a valid file (.xml, .xls, .xlsx).';
      }

      this.snackBar.open(
        message,
        'Close',
        {
          duration: 4000
        }
      );

      this.selectedFile = null;
      this.selectedFiles = [];

      event.target.value = '';

      return;
    }

    // ==========================================================
    // ASSIGN FILES
    // ==========================================================

    if (
      isCargoVan &&
      this.fileType === 'report'
    ) {

      this.selectedFiles =
        files;

      this.selectedFile =
        files[0] ?? null;

    } else {

      this.selectedFile =
        files[0];

      this.selectedFiles = [];
    }
  }

  // ============================================================
  // UPLOAD
  // ============================================================

  uploadFile(event: Event): void {

    event.preventDefault();

    const warehouseId =
      this.getWarehouseId();

    // ==========================================================
    // VALIDATE WAREHOUSE
    // ==========================================================

    if (!warehouseId) {

      this.snackBar.open(
        'Please select a warehouse.',
        'Close',
        {
          duration: 4000
        }
      );

      return;
    }

    // ==========================================================
    // VALIDATE FILE TYPE
    // ==========================================================

    if (!this.fileType) {

      this.snackBar.open(
        'Please select a file type.',
        'Close',
        {
          duration: 4000
        }
      );

      return;
    }

    // ==========================================================
    // GET WAREHOUSE
    // ==========================================================

    const wh =
      this.getSelectedWarehouse(
        warehouseId
      );

    if (!wh) {

      this.snackBar.open(
        'Warehouse not found.',
        'Close',
        {
          duration: 4000
        }
      );

      return;
    }

    const company =
      (wh.company ?? '')
        .toLowerCase()
        .trim();

    const isCargoVanReport =
      company === 'cargo van' &&
      this.fileType === 'report';

    // ==========================================================
    // VALIDATE FILES
    // ==========================================================

    if (isCargoVanReport) {

      if (!this.selectedFiles.length) {

        this.snackBar.open(
          'Please select at least one PDF file.',
          'Close',
          {
            duration: 4000
          }
        );

        return;
      }

    } else {

      if (!this.selectedFile) {

        this.snackBar.open(
          'Please select a file.',
          'Close',
          {
            duration: 4000
          }
        );

        return;
      }
    }

    // ==========================================================
    // START LOADING
    // ==========================================================

    this.isLoading = true;

    const formData =
      new FormData();

    if (!isCargoVanReport) {

      formData.append(
        'file',
        this.selectedFile!
      );
    }

    let request$: any;

    // ==========================================================
    // REPORT
    // ==========================================================

    if (
      this.fileType === 'report'
    ) {

      // --------------------------------------------------------
      // ONTRAC
      // --------------------------------------------------------

      if (
        company === 'ontrac'
      ) {

        request$ =
          this.core
            .uploadXmlFileOntrac(
              formData,
              warehouseId
            );
      }

      // --------------------------------------------------------
      // SPEEDX
      // --------------------------------------------------------

      else if (
        company === 'speedx'
      ) {

        request$ =
          this.core
            .uploadXmlFileOther(
              formData,
              warehouseId
            );
      }

      // --------------------------------------------------------
      // SWIFTX
      // --------------------------------------------------------

      else if (
        company === 'swiftx'
      ) {

        request$ =
          this.core
            .uploadSwiftXDspSummary(
              formData,
              warehouseId
            );
      }

      // --------------------------------------------------------
      // CARGO VAN
      // --------------------------------------------------------

      else if (
        company === 'cargo van'
      ) {

        request$ =
          this.core
            .uploadRouteManifestPdf(
              this.selectedFiles,
              warehouseId
            );
      }

      // --------------------------------------------------------
      // UNI UNI
      // --------------------------------------------------------

      else if (
        company === 'uni uni'
      ) {

        request$ =
          this.core
            .importUniUniDailyRoutes(
              this.selectedFile!,
              warehouseId
            );
      }

      // --------------------------------------------------------
      // UNSUPPORTED
      // --------------------------------------------------------

      else {

        this.isLoading = false;

        this.snackBar.open(
          `Unsupported company parser: ${wh?.company || 'Unknown'}`,
          'Close',
          {
            duration: 5000
          }
        );

        return;
      }
    }

    // ==========================================================
    // CLAIMS
    // ==========================================================

    else {

      request$ =
        this.core
          .uploadClaimsFile(
            formData
          );
    }

    // ==========================================================
    // SUBSCRIBE
    // ==========================================================

    request$.subscribe({

      next: (
        evt: HttpEvent<any>
      ) => {

        if (
          evt instanceof HttpResponse
        ) {

          const res =
            evt.body;

          // Clear files after successful response
          this.selectedFile = null;
          this.selectedFiles = [];

          // ====================================================
          // CLAIMS RESPONSE
          // ====================================================

          if (
            this.fileType === 'claims'
          ) {

            this.snackBar.open(
              `Claims imported successfully. Created: ${res?.created ?? 0}, Errors: ${res?.errors ?? 0}`,
              'Close',
              {
                duration: 6000
              }
            );

            if (
              res?.errorRows?.length
            ) {

              this.dialog.open(
                ImportResultComponent,
                {
                  width: '900px',
                  maxWidth: '95vw',
                  data: res
                }
              );
            }
          }

          // ====================================================
          // REPORT RESPONSE
          // ====================================================

          else {

            this.handleImportResponse(
              res,
              company
            );

            if (
              company !== 'ontrac' &&
              res
            ) {

              this.dialog.open(
                ImportResultComponent,
                {
                  width: '900px',
                  maxWidth: '95vw',
                  data: res
                }
              );
            }
          }
        }
      },

      // ========================================================
      // ERROR
      // ========================================================

      error: (err: any) => {

        console.error(
          'Upload error:',
          err
        );

        const payload =
          err?.error ?? err;

        if (
          this.fileType === 'claims'
        ) {

          const message =
            typeof payload === 'string'
              ? payload
              : payload?.message ||
                'Error importing claims file.';

          this.snackBar.open(
            message,
            'Close',
            {
              duration: 5000
            }
          );

        } else {

          this.handleImportResponse(
            payload,
            company
          );
        }

        this.isLoading = false;
      },

      // ========================================================
      // COMPLETE
      // ========================================================

      complete: () => {

        this.isLoading = false;
      }
    });
  }

  // ============================================================
  // CARGO VAN
  // ============================================================

  get isCargoVanSelected(): boolean {

    const warehouseId =
      this.getWarehouseId();

    if (!warehouseId) {
      return false;
    }

    const wh =
      this.getSelectedWarehouse(
        warehouseId
      );

    return (
      wh?.company ?? ''
    )
      .toLowerCase()
      .trim() === 'cargo van';
  }

  // ============================================================
  // IMPORT RESPONSE
  // ============================================================

  private handleImportResponse(
    payload: any,
    company: string
  ): void {

    if (!payload) {
      return;
    }

    const message =
      payload?.message ??
      'Done.';

    // Supports different backend property names
    const notFound: string[] =
      payload?.notFoundUsers ??
      payload?.notFountInUsers ??
      payload?.missingIdentificationNumbers ??
      [];

    this.snackBar.open(
      message,
      'Close',
      {
        duration: 6000
      }
    );

    // ==========================================================
    // ONTRAC MISSING DRIVERS
    // ==========================================================

    if (
      company === 'ontrac' &&
      notFound.length > 0
    ) {

      this.dialog.open(
        ImportResultComponent,
        {
          width: '900px',
          maxWidth: '95vw',

          data: {

            message,

            notFoundUsers:
              notFound,

            missingCount:
              notFound.length,

            warehouseId:
              this.selectedWarehouseId
          }
        }
      );
    }
  }
}



// filtered = this.navItemsData.find((obj) => {
//   return obj.displayName == this.searchinput;
// });

